import { Home, Users, Calendar, MessageCircle } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { useUnreadMessageCount } from '@/hooks/useMessages';

const navItems = [
  { icon: Home, label: 'Home', path: '/home' },
  { icon: Users, label: 'Directory', path: '/directory' },
  { icon: Calendar, label: 'Events', path: '/events' },
  { icon: MessageCircle, label: 'Messages', path: '/messages' },
];

export function MobileNav() {
  const { data: unreadCount } = useUnreadMessageCount();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border lg:hidden">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              cn(
                'relative flex flex-col items-center justify-center gap-1 px-2 py-2 rounded-lg transition-colors min-w-[48px]',
                isActive
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground'
              )
            }
          >
            {({ isActive }) => (
              <>
                <div className="relative">
                  <item.icon className={cn('h-5 w-5', isActive && 'text-primary')} />
                  {item.path === '/messages' && unreadCount && unreadCount > 0 && (
                    <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] bg-destructive text-destructive-foreground text-[10px] font-medium rounded-full flex items-center justify-center px-1">
                      {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                  )}
                </div>
                <span className="text-[10px] font-medium">{item.label}</span>
                {isActive && (
                  <span className="absolute bottom-2 w-1 h-1 bg-primary rounded-full" />
                )}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
